// extracted by mini-css-extract-plugin
module.exports = {"PaxRender":"PaxRender_PaxRender__1c6DP"};